var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgXmlDownload = function SvgXmlDownload(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 185.453 112",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".xml-download_svg__cls-1{fill:#414a5f}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xml-download_svg__xml-download",
    transform: "translate(-1523 -334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "xml-download_svg__Pfad_16845",
    d: "M192 272a7.97 7.97 0 0 1-5.657-2.343l-48-48a8 8 0 0 1 0-11.314l48-48a8 8 0 1 1 11.314 11.314L155.313 216l42.344 42.343A8 8 0 0 1 192 272",
    className: "xml-download_svg__cls-1",
    "data-name": "Pfad 16845",
    transform: "translate(1387 174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "xml-download_svg__Pfad_16846",
    d: "M320 272a8 8 0 0 1-5.657-13.657L356.687 216l-42.344-42.343a8 8 0 0 1 11.314-11.314l48 48a8 8 0 0 1 0 11.314l-48 48A7.97 7.97 0 0 1 320 272",
    className: "xml-download_svg__cls-1",
    "data-name": "Pfad 16846",
    transform: "translate(1332.452 174)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "xml-download_svg__Ellipse_80",
    cx: 8,
    cy: 8,
    r: 8,
    className: "xml-download_svg__cls-1",
    "data-name": "Ellipse 80",
    transform: "translate(1608 382)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "xml-download_svg__Ellipse_81",
    cx: 8,
    cy: 8,
    r: 8,
    className: "xml-download_svg__cls-1",
    "data-name": "Ellipse 81",
    transform: "translate(1632 382)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "xml-download_svg__Ellipse_82",
    cx: 8,
    cy: 8,
    r: 8,
    className: "xml-download_svg__cls-1",
    "data-name": "Ellipse 82",
    transform: "translate(1584 382)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgXmlDownload);
export default ForwardRef;